"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkForApplePay = exports.isMYATTApp = exports.ResponseHandlers = exports.NativeMethods = exports.WebkitTypes = void 0;
var StateProvider_1 = require("../api/StateProvider");
var localdatastore_1 = require("../config/localdatastore");
var FeatureService_1 = require("../api/FeatureService");
var event_bus_1 = require("@idp/event-bus");
var Events_1 = require("../api/Events");
var UtilityFunctions_1 = require("./UtilityFunctions");
var CheckoutApi_1 = require("../api/CheckoutApi");
var WebkitTypes;
(function (WebkitTypes) {
    WebkitTypes["MOCK"] = "MOCK";
    WebkitTypes["ORIGINAL"] = "ORIGINAL";
    WebkitTypes["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(WebkitTypes = exports.WebkitTypes || (exports.WebkitTypes = {}));
/**
 * @class NativeService
 * @description use to make iOS native interactions
 */
var NativeServices = /** @class */ (function () {
    function NativeServices() {
        var _this = this;
        this.STORE_NAME = 'applePayStatus';
        this.id = event_bus_1.ICCEventBusManager.getUUID();
        this.webKitStatus = WebkitTypes.NOT_AVAILABLE;
        this.events = new Events_1.default([NativeServices.name, 'AppleDebugConsole']);
        this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        this.nativeErrorResponse = this.nativeErrorResponse.bind(this);
        this.nativeSuccessResponse = this.nativeSuccessResponse.bind(this);
        this.onFeatureStatusRetrival = this.onFeatureStatusRetrival.bind(this);
        this.injectMockKit = this.injectMockKit.bind(this);
        this.checkoutApi = new CheckoutApi_1.default();
        var thisPointer = this;
        window.nativeServices = this;
        window.applePaySupportedError = function (error) {
            thisPointer.nativeErrorResponse(error);
        };
        window.applePaySupportedSuccess = function (response) {
            thisPointer.nativeSuccessResponse(response);
        };
        /* istanbul ignore next */
        window.invokeApplePayError = function (error) {
            var _a;
            thisPointer.debugApplePay('invokeApplePayError', true);
            thisPointer.debugApplePay(error.errorString);
            thisPointer.debugApplePay(error.statusCode);
            (_a = _this.checkoutApi) === null || _a === void 0 ? void 0 : _a.logDataToElk('CHECKOUT_APPLE_ERROR_INVOKE', JSON.stringify(error || {}), {});
            thisPointer.nativeEvents.errorCallback(error);
        };
        /* istanbul ignore next */
        window.invokeApplePaySuccess = function (response) {
            var _a;
            thisPointer.debugApplePay('invokeApplePaySuccess', true);
            thisPointer.debugApplePay(response);
            (_a = _this.checkoutApi) === null || _a === void 0 ? void 0 : _a.logDataToElk('CHECKOUT_APPLE_SUCCESS_INVOKE', JSON.stringify(response || {}), JSON.stringify(thisPointer.nativeEvents || {}));
            thisPointer.nativeEvents.invokeApplePaySuccess(response);
        };
        if (!isMYATTApp()) {
            if (this.stateManager.get(localdatastore_1.getNamespace('CHECKOUT'), 'featureToggles')) {
                this.onFeatureStatusRetrival();
            }
            else {
                this.registerFeatureObserver = this.registerFeatureObserver.bind(this);
                this.registerFeatureObserver();
                FeatureService_1.default.getInstance();
            }
        }
        else {
            this.webKitStatus = WebkitTypes.ORIGINAL;
            this.events.fireEvent({ status: 'Native Service Found' }, NativeServices.name);
        }
    }
    NativeServices.getInstance = function () {
        return NativeServices.instance;
    };
    /* istanbul ignore next */
    NativeServices.prototype.getNativeServicesStatus = function () {
        return this.webKitStatus;
    };
    /* istanbul ignore next */
    NativeServices.prototype.isApplePaySupported = function (events) {
        var _a, _b;
        this.nativeEvents = events;
        // tslint:disable-next-line:no-any
        try {
            if (isMYATTApp()) {
                var request = this.generateRequestObject(NativeMethods.IS_APPLE_PAY_SUPPORTED, {
                    supportedCardTypes: ['visa', 'masterCard', 'amex', 'discover'],
                });
                this.debugApplePay('isApplePaysupported going to be called and this is the request object');
                this.debugApplePay(JSON.stringify(request));
                this.debugApplePay(request);
                if (!window.webkit) {
                    this.debugApplePay('Webkit is not found');
                }
                window.webkit.messageHandlers.myAtt.postMessage(request);
            }
            else {
                var errorString = 'NativeServices :: isApplePaySupported : iphone : webkit.messageHandlers undefined';
                var status_1 = 1;
                this.debugApplePay(errorString);
                this.notifyApplePayError(errorString, status_1, events);
            }
        }
        catch (e) {
            this.debugApplePay(e === null || e === void 0 ? void 0 : e.toString);
            this.debugApplePay((_a = e === null || e === void 0 ? void 0 : e.stack) === null || _a === void 0 ? void 0 : _a.toString());
            this.notifyApplePayError(e === null || e === void 0 ? void 0 : e.toString(), (_b = e === null || e === void 0 ? void 0 : e.stack) === null || _b === void 0 ? void 0 : _b.toString(), events);
        }
    };
    NativeServices.prototype.invokeApplePay = function (events, amount, merchantId) {
        var _a;
        this.nativeEvents = events;
        // tslint:disable-next-line:no-any
        var errorMessages = this.stateManager.get(localdatastore_1.getNamespace('CHECKOUT'), 'nativeErrorMessages');
        try {
            var request = this.generateRequestObject(NativeMethods.INVOKE_APPLE_PAY, {
                amountDetails: {
                    amount: amount,
                    label: 'AT&T',
                    type: 'final',
                },
                countryCode: 'US',
                currencyCode: 'USD',
                inputBillingAddress: {
                    postalCode: {
                        errorMessage: errorMessages ? errorMessages.zipCodeError : '',
                        regExValidation: '\\d{5}',
                    },
                },
                merchantCapability: 'supports3DS',
                merchantId: merchantId,
                supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
            });
            this.debugApplePay(JSON.stringify(request));
            this.debugApplePay(request);
            if (!window.webkit) {
                this.debugApplePay('web kit is not found');
            }
            window.webkit.messageHandlers.myAtt.postMessage(request);
        }
        catch (e) {
            this.debugApplePay('NativeServices::Error::' + (e === null || e === void 0 ? void 0 : e.toString()));
            this.notifyApplePayError(e === null || e === void 0 ? void 0 : e.toString(), (_a = e === null || e === void 0 ? void 0 : e.stack) === null || _a === void 0 ? void 0 : _a.toString(), events);
        }
    };
    // tslint:disable-next-line:no-any
    NativeServices.prototype.debugApplePay = function (data, flush) {
        this.events.fireEvent({ message: data, flush: flush }, 'AppleDebugConsole');
        console.log(data);
    };
    NativeServices.prototype.generateRequestObject = function (methodName, data) {
        var request = {
            callbackName: '',
            data: data,
            errorCallbackName: '',
            functionName: methodName,
            module: 'ApplePay',
        };
        if (methodName === NativeMethods.IS_APPLE_PAY_SUPPORTED) {
            request.callbackName = 'applePaySupportedSuccess';
            request.errorCallbackName = 'applePaySupportedError';
        }
        else if (methodName === NativeMethods.INVOKE_APPLE_PAY) {
            request.callbackName = 'invokeApplePaySuccess';
            request.errorCallbackName = 'invokeApplePayError';
        }
        request.functionName = methodName;
        return request;
    };
    /* istanbul ignore next */
    NativeServices.prototype.onFeatureStatusRetrival = function () {
        var featureService = FeatureService_1.default.getInstance();
        var mock = featureService.getFeatureStatus(FeatureService_1.FeatureNames.MOCK_MYATT);
        if (mock) {
            this.injectMockKit();
            this.webKitStatus = WebkitTypes.MOCK;
            this.events.fireEvent({ status: 'Mock Object Injected' }, NativeServices.name);
        }
        // ICCEventBusManager.getInstance().deregisterObserver(this.id);
    };
    NativeServices.prototype.registerFeatureObserver = function () {
        var featureObserver = {
            eventHandler: this.onFeatureStatusRetrival,
            observerId: this.id,
            serviceName: FeatureService_1.default.name,
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(featureObserver);
    };
    NativeServices.prototype.notifyApplePayError = function (errorString, statusCode, events) {
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem("CART:" + this.STORE_NAME, JSON.stringify({
            isSupported: false,
            isSupportedCardFound: false,
        }));
        events.errorCallback({ errorString: errorString, statusCode: statusCode });
    };
    NativeServices.prototype.nativeSuccessResponse = function (response) {
        this.debugApplePay('nativeSuccessResponse received response');
        this.debugApplePay('isSupportedValue ' + response.isSupported);
        this.debugApplePay('isSupportedValueType:' + typeof (response.isSupported));
        this.debugApplePay('isSuupportedCardFound: ' + response.isSupportedCardFound);
        this.debugApplePay('isSupportedCardFoundValueType:' + typeof (response.isSupportedCardFound));
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem("CART:" + this.STORE_NAME, JSON.stringify(response));
        this.nativeEvents.isApplePaySupportedSuccess(response);
    };
    NativeServices.prototype.nativeErrorResponse = function (response) {
        this.debugApplePay('nativeErrorResponse');
        this.debugApplePay(response.errorString);
        this.debugApplePay(response.statusCode);
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem("CART:" + this.STORE_NAME, undefined);
        this.nativeEvents.errorCallback(response);
    };
    /* istanbul ignore next */
    NativeServices.prototype.injectMockKit = function () {
        var webkit = {
            messageHandlers: {
                myAtt: {
                    // tslint:disable-next-line:no-any
                    postMessage: function (request) {
                        if (request.functionName === 'isApplePaySupported') {
                            var featureService = FeatureService_1.default.getInstance();
                            if (featureService.getFeatureStatus(FeatureService_1.FeatureNames.APPLE_PAY_SUPPORTED_SUCCESS)) {
                                if (featureService
                                    .getFeatureStatus(FeatureService_1.FeatureNames.APPLE_PAY_SUPPORTED_SUCCESS_NO)) {
                                    window.applePaySupportedSuccess({
                                        isSupported: false,
                                        isSupportedCardFound: false,
                                    });
                                }
                                else {
                                    window.applePaySupportedSuccess({
                                        isSupported: true,
                                        isSupportedCardFound: true,
                                    });
                                }
                            }
                            else {
                                window.applePaySupportedError({
                                    errorString: 'errorString',
                                    statusCode: 0,
                                });
                            }
                        }
                        else if (request.functionName === 'invokeApplePay') {
                            var featureService = FeatureService_1.default.getInstance();
                            if (featureService.getFeatureStatus(FeatureService_1.FeatureNames.INVOKE_APPLE_PAY_DONE)) {
                                var confirmResult = confirm('Made your choice: Buy with Apple Pay');
                                var paymentData1 = 'eyJ2ZXJzaW9uIjoiRUNfdjEiLCJkYXRhIjoibjJkMVROZXJoNUV1SXJIcTAwa0ZFbUwra3pwbzNCaGVaWk5heFUvKzN3OWNod05vYn';
                                var paymentData2 = 'lndHVHdXk3dEpaRldxbURGYzR5R3VlaEo5eHpocGxsbGxpeERwTFZxMDVtL3Bib3lvQW4yc0lGSjNLWW1PTk9ZUzlnazBQSEdEZFB6cnlEMFBlQTF';
                                var paymentDatafinal = "" + paymentData1 + paymentData2 + "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";
                                var successResponse = {
                                    billingContact: {
                                        name: {
                                            familyName: 'Xlow',
                                            givenName: 'Test',
                                        },
                                        postalAddress: {
                                            city: 'ABC',
                                            country: '',
                                            postalCode: '75074',
                                            state: 'TX',
                                            street: '',
                                        },
                                    },
                                    paymentData: paymentDatafinal,
                                    paymentMethod: {
                                        displayName: 'Pay AT&T',
                                        network: 'MASTERCARD',
                                        type: 'type',
                                    },
                                    statusCode: confirmResult ? 0 : 1,
                                    transactionIdentifier: '093u645jklsdfihdgdhg',
                                };
                                if (featureService.getFeatureStatus(FeatureService_1.FeatureNames.INVOKE_APPLE_PAY_CANCEL)) {
                                    successResponse.statusCode = 1;
                                }
                                window.invokeApplePaySuccess(successResponse);
                            }
                            else {
                                window.invokeApplePayError({
                                    errorString: 'mock errorString',
                                    statusCode: 1,
                                });
                            }
                        }
                    },
                },
            },
        };
        window.webkit = webkit;
    };
    NativeServices.instance = new NativeServices();
    return NativeServices;
}());
exports.default = NativeServices;
var NativeMethods;
(function (NativeMethods) {
    NativeMethods["IS_APPLE_PAY_SUPPORTED"] = "isApplePaySupported";
    NativeMethods["INVOKE_APPLE_PAY"] = "invokeApplePay";
})(NativeMethods = exports.NativeMethods || (exports.NativeMethods = {}));
var ResponseHandlers;
(function (ResponseHandlers) {
})(ResponseHandlers = exports.ResponseHandlers || (exports.ResponseHandlers = {}));
/* istanbul ignore next */
function isMYATTApp() {
    var cookieVal = UtilityFunctions_1.getCookie('accessDomain');
    if (cookieVal && cookieVal.toLowerCase() === 'native') {
        return true;
    }
    else {
        // tslint:disable:no-any
        var webkit = window === null || window === void 0 ? void 0 : window.webkit;
        var isMyAttApp = (typeof webkit !== 'undefined' && webkit != null) &&
            (typeof (webkit === null || webkit === void 0 ? void 0 : webkit.messageHandlers) !== 'undefined' && (webkit === null || webkit === void 0 ? void 0 : webkit.messageHandlers) != null);
        return !!isMyAttApp;
    }
}
exports.isMYATTApp = isMYATTApp;
function checkForApplePay() {
    /* istanbul ignore next */
    if (isMYATTApp()) {
        var nativeServices = NativeServices.getInstance();
        nativeServices.isApplePaySupported({
            errorCallback: function (error) {
                console.log(error);
            },
            isApplePaySupportedSuccess: function (response) {
                console.log(response);
            },
        });
    }
}
exports.checkForApplePay = checkForApplePay;
//# sourceMappingURL=NativeServices.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/utils/NativeServices.js
// module id = 974
// module chunks = 8